export default {
  HUMAN_TRANSCRIPTION_REQUIRED: 'HUMAN_TRANSCRIPTION_REQUIRED',
  AI_TRANSCRIPTION_REQUIRED: 'AI_TRANSCRIPTION_REQUIRED',
  MULTI_FACTOR_AUTHORIZATION: 'MULTI_FACTOR_AUTHORIZATION',
  DOWNLOAD_CALL_RECORDINGS: 'DOWNLOAD_CALL_RECORDINGS',
};



// WEBPACK FOOTER //
// ./config/rules-constants.js